import { useSetAtom } from 'jotai';

import oneTrustConsentAtom from './oneTrustConsentAtom';

const useSetOneTrustConsent = () => {
  const setOTConsent = useSetAtom(oneTrustConsentAtom);

  return setOTConsent;
};

export default useSetOneTrustConsent;
